import React, { createContext } from 'react';

const CheckoutContext = createContext(null);

export default CheckoutContext;
